import React from 'react';

function AppPageTitle({ title, extra }) {
  return (
    <div className="flex items-center justify-between my-2 w-full">
      <h1 className="font-medium text-2xl">{title}</h1>
      {extra && <div className="ml-4">{extra}</div>}
    </div>
  );
}

export default AppPageTitle;
